<template>
    <div class="zq-videos__item">
        <div class="zq-video__container">
            <iframe class="zq-video__youtube-embed" width="560" height="315"
                    :src="'https://www.youtube.com/embed/'+video.id + '?rel=0'"  frameborder="0"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
<!--          <iframe class="zq-video__youtube-embed" width="560" height="315"-->
<!--                    :src="'https://www.youtube.com/embed/'+video.id" frameborder="0"-->
<!--                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"-->
<!--                    allowfullscreen></iframe>-->
        </div>
        <div class="zq-videos__copy-link">
            <h4>{{video.title}}</h4>
        </div>
    </div>
</template>
<script>

    export default {
        name: 'youtube-video',
        components: {},
        props: {
            'video': {}
        },
    }
</script>